import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { Submenu } from '../../../../vtex-apps/menu/Submenu/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';

export default function TopHeader() {
	return {
		componentName: 'FlexLayoutRow',
		componentId: uuidv4(),
		variables,
		componentGroup: 'TopHeader',
		props: FlexLayoutRow({ blockClass: 'mz-top-heaer-1', colSizing: 'auto' }).props,
		childrenComponents: [
			RichText({
				text: 'Há 26 anos oferecendo materiais médico-hospitalares de qualidade em todo Brasil',
				blockClass: 'mz-top-header-1-text',
			}),
			Menu({}, [
				MenuItem(
					{
						id: 'menu-item-category-apparel',
						blockClass: 'mz-top-header-1-menu',
						type: 'custom',
						iconId: null,
						highlight: false,
						itemProps: {
							type: 'internal',
							href: '/',
							noFollow: false,
							tagTitle: 'Central de Atendimento',
							text: 'Central de Atendimento',
							itemType: 'custom',
						},
					},
					[
						Submenu({}, [
							Menu(
								{
									orientation: 'vertical',
								},
								[
									MenuItem({
										id: 'item-2',
										blockClass: 'mz-top-header-1-menu-item',
										type: 'custom',
										iconId: null,
										highlight: true,
										itemProps: {
											type: 'internal',
											href: 'https://wa.me/11912345678',
											noFollow: false,
											tagTitle: 'Fale com a gente pelo WhatsApp',
											text: 'Fale com a gente pelo WhatsApp',
											itemType: 'custom',
										},
									}),
									MenuItem({
										id: 'item',
										blockClass: 'mz-top-header-1-menu-item',
										type: 'custom',
										iconId: null,
										highlight: true,
										itemProps: {
											type: 'internal',
											href: '/contato',
											noFollow: false,
											tagTitle: 'Envie seu contato para a gente',
											text: 'Envie seu contato para a gente',
											itemType: 'custom',
										},
									}),
									MenuItem({
										id: 'item-3',
										blockClass: 'mz-top-header-1-menu-item',
										type: 'custom',
										iconId: null,
										highlight: false,
										itemProps: {
											type: 'internal',
											href: '/',
											noFollow: false,
											tagTitle: 'Atendimento: de Segunda a Sexta-feira das 09:00 às 18:00 e Sábado das 08:00 às 13:00',
											text: 'Atendimento: de Segunda a Sexta-feira das 09:00 às 18:00 e Sábado das 08:00 às 13:00',
											itemType: 'custom',
										},
									}),
								],
							),
						]),
					],
				),
				RichText({
					text: '[Peça um orçamento](https://google.com)',
					blockClass: 'mz-top-header-1-link',
				}),
			]),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--tg-2-background', name: 'Background' },
			{ from: '--text-color-1', to: '--tg-2-text-color', name: 'Text' },
			{ from: '--brand-color-primary-pure', to: '--tg-2-slider-color', name: 'Slider' },
			{ from: '--white', to: '--tg-2-slider-arrow-color', name: 'Arrow' },
			{ from: '--brand-color-primary-pure', to: '--tg-2-dots-color', name: 'Dots' },
		],
	},
	{
		type: 'borderRadius',
		list: [{ from: '--border-radius-sm', to: '--tg-2-slider-radius', name: 'Slider Border Radius' }],
	},
	{
		type: 'fontWeight',
		list: [{ from: '--font-weight-700', to: '--tg-2-text-fw', name: 'Text' }],
	},
	{
		type: 'fontSize',
		list: [{ from: '--font-size-sm', to: '--tg-2-text-fs', name: 'Text' }],
	},
	{
		type: 'typography',
		list: [{ from: '--main-font', to: '--tg-2-ff', name: 'Font Family' }],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-xxs', to: '--tg-2-dot-width', name: 'Dot Width' },
			{ from: '--spacing-xxs', to: '--tg-2-dot-width-active', name: 'Dot Width Active' },
			{ from: '--spacing-nano', to: '--tg-2-dot-height', name: 'Dot Height' },
			{ from: '--spacing-nano', to: '--tg-2-dot-height-active', name: 'Dot Height Active' },
		],
	},
];
